import { useState } from "react";
import { usePassareExport } from "./usePassareExport";
import PassareFilterList, { PassareFilterObject } from "./PassareFilterList";
import ExportAllLeadsModal from "../../../../../../mogul/modals/ExportAllLeadsModal";
import FilterListButton from "../shared/FilterListButton";

export default function PassareTableHeader({
    title,
    subtitle = '',
    filterLocalStorageKey,
    currentFilter,
    onApplyFilter,
    onNavigateToManage,
    onNavigateBack,
    searchBar,
    personSearchFilter,
    onSyncAll,
    unsyncedLeadsCount
}: {
    title: string;
    subtitle?: string;
    filterLocalStorageKey: string;
    currentFilter: PassareFilterObject | null;
    onApplyFilter: (filterObject: PassareFilterObject) => void;
    onNavigateToManage?: () => void;
    onNavigateBack?: () => void;
    searchBar?: React.ReactNode;
    personSearchFilter?: string;
    onSyncAll?: () => void;
    unsyncedLeadsCount?: number;
}) {

    const [viewingFilter, setViewingFilter] = useState(false)

    const {
        exporting,
        errorExporting,
        onExportLeadListToCSV
    } = usePassareExport()

    return <>
        {/* begin::Header */}
        <div className='card-header align-items-center border-0 mt-3'>
            <h3 className='card-title align-items-start flex-column'>
                <span className='fw-bolder text-dark fs-3'>
                    {title}
                </span>
                {subtitle && <span className='text-gray-400 mt-2 fw-bold fs-6'>{subtitle}</span>}
            </h3>
            {searchBar && <div className='ms-auto me-4'>{searchBar}</div>}
            <div className='card-toolbar'>
                {!onNavigateBack && onSyncAll && (unsyncedLeadsCount || 0) > 0 && (
                    <button
                        className='btn btn-sm btn-warning me-2'
                        onClick={onSyncAll}
                    >
                        <span className='d-none d-md-inline'>
                            Sync All ({unsyncedLeadsCount})
                        </span>
                        <span className='d-md-none'>
                            Sync ({unsyncedLeadsCount})
                        </span>
                    </button>
                )}
                {!onNavigateBack && (
                    <button
                        className='btn btn-sm btn-light me-2'
                        data-bs-toggle='modal'
                        data-bs-target='#modal_export_all_leads'
                    >
                        <span className='d-none d-md-inline'>
                            Export
                        </span>
                    </button>
                )}
                {onNavigateToManage && (
                    <button
                        className='btn btn-sm btn-primary me-2'
                        onClick={onNavigateToManage}
                    >
                        <span className='d-none d-md-inline'>
                            Manage
                        </span>
                    </button>
                )}
                {onNavigateBack && (
                    <button
                        className='btn btn-sm btn-secondary me-2'
                        onClick={onNavigateBack}
                    >
                        <span className='d-none d-md-inline'>
                            Back
                        </span>
                    </button>
                )}
                <ExportAllLeadsModal
                    filterChild={<PassareFilterList
                        isFilterChild
                        onReset={() => {
                        }}
                        onCancel={() => { }}
                        currentFilterObject={currentFilter}
                        onApplyFilter={() => { }}
                    />}
                    exporting={exporting}
                    errorExporting={errorExporting}
                    onExport={() => {
                        if (currentFilter) {
                            onExportLeadListToCSV(currentFilter)
                        } else {
                            onExportLeadListToCSV({} as PassareFilterObject)
                        }
                    }}
                    disableExportForReason={
                        (currentFilter?.selectedPassareOrganizationUniqueIds.length || 0) === 0
                            ? 'You need to select at least one organization to export leads.'
                            : ''
                    }
                />
                {!onNavigateBack && (
                    <FilterListButton
                        onClick={() => {
                            setViewingFilter(true)
                        }}
                        hasFiltersApplied={
                            (currentFilter?.selectedPassareOrganizationUniqueIds?.length || 0) > 0 ||
                            (currentFilter?.selectedBranchNames?.length || 0) > 0 ||
                            !!currentFilter?.onlyUnSyncedWith360 ||
                            !!currentFilter?.showAllLeadsEvenIfLocationIsIgnored ||
                            !!currentFilter?.showAllLeadsRegardlessOfContactQuality ||
                            !!currentFilter?.startingUnixTimestamp ||
                            !!currentFilter?.endingUnixTimestamp
                        }
                    />
                )}
            </div>
        </div>
        {/* end::Header */}
        {viewingFilter && <>
            <PassareFilterList
                onReset={() => {
                    onApplyFilter({
                        selectedPassareOrganizationUniqueIds: [],
                        onlyUnSyncedWith360: false,
                        showAllLeadsEvenIfLocationIsIgnored: false,
                        startingUnixTimestamp: undefined,
                        endingUnixTimestamp: undefined,
                    })
                    localStorage.removeItem(filterLocalStorageKey)
                }}
                onCancel={() => setViewingFilter(false)}
                currentFilterObject={currentFilter}
                onApplyFilter={(filterObject: PassareFilterObject) => {
                    onApplyFilter(filterObject)
                    setViewingFilter(false)
                    localStorage.setItem(filterLocalStorageKey, JSON.stringify(filterObject))
                }}
            />
        </>}
    </>

}